import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useMemo } from 'react';
import { useGetRewardTransactionsQueryQuery } from "./get-reward-transactions-query.v5.generated";
export var useRewardTransactionsV2 = function useRewardTransactionsV2(_ref) {
  var _data$user_reward_tra2;
  var transactionType = _ref.transactionType;
  var _useGetRewardTransact = useGetRewardTransactionsQueryQuery({
      context: {
        clientName: 'v5'
      },
      variables: {
        transaction_type: transactionType
      }
    }),
    data = _useGetRewardTransact.data,
    loading = _useGetRewardTransact.loading,
    error = _useGetRewardTransact.error,
    refetch = _useGetRewardTransact.refetch;
  var handleRefetch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return refetch === null || refetch === void 0 ? void 0 : refetch();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleRefetch() {
      return _ref2.apply(this, arguments);
    };
  }();
  var dataRewardTransactions = useMemo(function () {
    var _data$user_reward_tra;
    return (data === null || data === void 0 ? void 0 : (_data$user_reward_tra = data.user_reward_transactions) === null || _data$user_reward_tra === void 0 ? void 0 : _data$user_reward_tra.edges.map(function (edge) {
      return edge.node;
    })) || [];
  }, [data === null || data === void 0 ? void 0 : (_data$user_reward_tra2 = data.user_reward_transactions) === null || _data$user_reward_tra2 === void 0 ? void 0 : _data$user_reward_tra2.edges]);
  return {
    dataRewardTransactions: dataRewardTransactions,
    loadingRewardTransactions: loading,
    errorRewardTransactions: error,
    refetchRewardTransactions: handleRefetch
  };
};